import { apiErrorInfo } from '../../utils/apiErrorInfo';
import {
  getAdvertisement,
  listAdvertisements,
  type Advertisement,
} from '../../services/advertisementService';

/**
 * A failure that replaces the whole board rather than one card's message:
 * - 'session': 401, the sign-in is gone (apiClient already tried a refresh)
 * - 'professional': 403 PROFESSIONAL_ACCOUNT_REQUIRED, the server says this
 *   account is not professional (requireProfessional)
 * - 'disabled': 404 from the list or a post, the board's feature flag is off
 */
export type BoardIssue = 'session' | 'professional' | 'disabled';

/** The page-level issue behind a 401 or a professional 403, or null for anything else. */
export function boardIssueOf(error: unknown): BoardIssue | null {
  const { status, code } = apiErrorInfo(error);
  if (status === 401) return 'session';
  if (status === 403 && code === 'PROFESSIONAL_ACCOUNT_REQUIRED') return 'professional';
  return null;
}

/**
 * Signed-in reads of the Requests board «لوحة الطلبات».
 *
 * Since the 2026-10 overhaul every /api/advertisements route, reads included,
 * sits behind requireAuth + requireProfessional (backend routes/advertisements.js),
 * so a read without a token is a 401. The calls live in
 * services/advertisementService.ts with the writes; these are the board's names
 * for them.
 */

/** The newest open requests (the backend returns at most 50). */
export function listOpenRequests(token: string): Promise<Advertisement[]> {
  return listAdvertisements(token, { status: 'open' });
}

/** One request with its replies, oldest reply first. */
export function getRequest(token: string, id: string): Promise<Advertisement | null> {
  return getAdvertisement(token, id);
}
